import React from "react";

import { Box, Typography } from "@mui/material";

import {
  ServiceHours,
  CARD_BORDER_COLOR,
} from "../../constants/contactChannels.constants";

interface ServiceHoursFooterProps {
  hours: ServiceHours;
}

export const ServiceHoursFooter = ({ hours }: ServiceHoursFooterProps) => {
  return (
    <Box
      sx={{
        mt: 2.5,
        p: { xs: "12px", sm: "16px 20px" },
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
        border: `1px solid ${CARD_BORDER_COLOR}`,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 700,
          fontSize: "1.4rem",
          color: "text.primary",
          mb: 1,
          textTransform: "uppercase",
        }}
      >
        Horários de Atendimento da Central
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "#58595B", fontSize: "1.3rem", lineHeight: 1.6 }}
      >
        {hours.weekdays}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "#58595B", fontSize: "1.3rem", lineHeight: 1.6 }}
      >
        {hours.weekendsAndHolidays}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "#999999", fontSize: "1.2rem", mt: 0.5 }}
      >
        *{hours.timezoneNote}
      </Typography>
    </Box>
  );
};
